import config from "../../Constants/Config";
import { RoutePaths } from "../../Constants/RoutePaths";

export function GetArticleShareUrl(urlTitle?: string | null, articleId?: number) {
    // IDs work for new Studio articles without publishing a legacy read-site slug.
    if (articleId && Number.isSafeInteger(articleId) && articleId > 0) {
        return "https://www.ickonic.com" + RoutePaths.ReadArticle(articleId);
    }
    const slug = urlTitle?.trim();
    if (!slug) return "https://www.ickonic.com" + RoutePaths.BrowseArticles;
    if (/^https?:\/\//i.test(slug)) return slug;
    return config.articleShare + slug;
}

const irregularPlurals: Record<string, string> = {
    child: "children",
    person: "people",
    man: "men",
    woman: "women",
};

const pluralize = (word: string): string => {
    const lowerWord = word?.toLowerCase();

    if (irregularPlurals[lowerWord]) {
        return irregularPlurals[lowerWord];
    }

    if (lowerWord?.endsWith("y") && !/[aeiou]y$/.test(lowerWord)) {
        return word.slice(0, -1) + "ies";
    }

    if (/s$|sh$|ch$|x$|z$/.test(lowerWord)) {
        return `${word}es`;
    }

    return `${word}s`;
};

export const getPlural = (count: number, title: string): string => {
    const pluralTitle = count === 1 ? title : pluralize(title);
    return `${count} ${pluralTitle}`;
};
